import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import chairman from "../assets/img/oasis/chairman.jpeg";
import { Helmet } from "react-helmet-async";

const ChairmanMessage = () => {
  return (<>
    <Helmet>
      <title>Chairman's Message</title>
      <meta name="description" content=" Oasis Educational Institute" />
    </Helmet>

    <Container fluid className="m-4">
      <header className="p-5 ">
        <h1>Chairman's Message</h1>
      </header>

      <section>
        <Row className="align-items-center">
          <Col md={8} className="p-5 mt-2">
            <h2>MESSAGE FROM CHAIRMAN</h2>
            <p><strong>Mr. Ashiq Hussain Masoodi</strong></p>
            <p><strong>Chairman, OASIS Group of Schools</strong></p>
          </Col>

          <Col md={4} className="d-flex justify-content-center ">
            <img
              src={chairman}
              alt="Chairman"
              className="img-fluid pt-2 rounded-circle"
              style={{ width: '170px', height: '170px' }}
            />
          </Col>
        </Row>
      </section>

      <article className='text-align-center ps-2 me-2 pe-4 py-2 line-height-3'>
        <p>
          True education is the harmonious development of the physical, mental, social and spiritual dimensions of a student. Oasis Educational Institute is committed to Excellence in education and will embrace changing social realities and technology that will have a profound impact on your child and our changing World whether it is in the classroom laboratory or the World at large.
        </p>

        <p className='pt-3'>
          I remember how a small step taken in 2004 led to the birth of Oasis and the hectic activities behind the scenes which were not only new to us but unknown as well. The years have flown by and it is almost 21th year of our School. It has been a momentous journey, full of ups and downs. But each compliment inspired us, each criticism sent us back to the drawing board to rethink and relearn. We are constantly evolving. changing and innovating.
        </p>

        <p className='pt-3'>
          The Oasis group of schools had its humble beginning with Oasis, Karan Nagar with the soul aim of imparting quality education; it spread its tentacles and established its branchesat Rawalpora, GogjiBagh and Bemina.
        </p>

        <p className='pt-3'>
          These schools provide such educational environs that parents preferred to send wards to these schools and consequently there was constant demand from the parent and civil society that Oasis branches of schools should have its own Higher Secondary School. It is because of this demand that Public high school was overtaken by the management of Oasis group and results are on the ground as every year, the students appearing in board exams quafify exams with flying colors, thus not only giving fame and reputation to their parents but also to the Oasis group of schools.
        </p>
        <p className='pt-3'>
          In short spell of its establishment, the Oasis group of schools stand as a cult and has its presence felt in a big way in the education arena of the valley right from its inception
        </p>
        <p className='pt-3'>
          The strategic plan of Oasis Higher Secondary Educational Institute is to build on its existing strengths and make necessary improvements to develop a strong institution for a better tomorrow At Oasis Higher Secondary Educational Institute, we are committed to provide holistic value-based education to every child that enrolls in this Institution. Student satisfaction is our priority. Our experienced and committed teachers drive to motivate students to achieve academic excellence and have an enjoyable learning experience Furthermore, Oasis school has got affiliated to Cambridge International Examination, thus becoming the first school in the valley registered as a Cambridge International School
        </p>
        <p className='pt-3'>
          With a blend of resources, infrastructure and dedicated teaching faculty we train students and equip them to meet the challenges of the modern world as well as foster value of honesty, compassion and collaboration, helping them become pillars of modern society and the world
        </p>
        <footer className='pt-3'>
          <p>Thank you for choosing to be a part of our amazing learning community at Oasis Higher Secondary Educational Institute Students your success is paramount to us and we will leave no stone unturned to help you achieve academic, co-curricular and social success. May God guide you in all your endeavors.</p>
        </footer>
      </article>
    </Container>
  </>

  );
};

export default ChairmanMessage;
